import * as React from 'react';
import {useEffect, useState} from "react";
import {
    Action,
    APP_LANDING,
    APP_LOGIN_PATH,
} from "../../types";
import {useHistory} from "react-router";
import {useLocation, Link} from "react-router-dom";
import {currentSession} from "../../Auth";
import {getUserProfile} from "../../api";

const ActionSelection: React.FunctionComponent = () => {

    let [actions, setActions] = useState<Action[]>([]);
    let [doRedirectToLanding, setDoRedirectToLanding] = useState(false);
    let [doRedirectToLogin, setDoRedirectToLogin] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const fullPath = location.pathname;


    useEffect(() => {
        currentSession().then(session => {
        }).catch(e => {
            setDoRedirectToLogin(true);
        })
    }, [fullPath, history]);

    useEffect(() => {
        if (doRedirectToLanding) {
            history.push({
                pathname: APP_LANDING
            });
        }
    }, [doRedirectToLanding, history]);

    useEffect(() => {
        if (doRedirectToLogin) {
            history.push({
                pathname: APP_LOGIN_PATH
            });
        }
    }, [doRedirectToLogin, history]);

    useEffect(() => {
       // setDoRedirectToLanding(true);
        getUserProfile()
            .then(user => {
                if (user.actions && user.actions?.length > 0) {
                    setActions(user.actions);
                } else {
                    setDoRedirectToLanding(true);
                }
            })
            .catch(e => console.log(e));
    }, []);


    const getPathByCode = (code: string) => {
        switch (code) {
            case "account-activation-required":
                return "/a/activation-required";
            case "login-code":
                return "/a/login-code";
            default:
                return "";
        }
    }


    return ((!actions) ? <>Loading...</> : <>
        <div className={"container mt-3 text-center"}>
            <div className={"row justify-content-md-center mb-3"}>
                <img alt={"logo"} src={"/assets/dist/img/promises12_logo.jpg"}/>
            </div>
            <div className={"row justify-content-md-center"}>
                <div className={"col-lg-4 mb-3"}>
                    <h1 className="h3 mb-3 font-weight-normal">This account has action items.</h1>
                    <p>Select from the following action items to resolve.</p>
                </div>
            </div>
            <div className={"row justify-content-md-center"}>
                <div className={"col-lg-4 mb-3"}>
                    <div className="list-group">
                        {
                            actions.map(p => (
                                <Link to={getPathByCode(p.code)}>
                                    <button key={p.code} type="button"
                                            className="list-group-item list-group-item-action">
                                        {p.description}
                                    </button>
                                </Link>
                            ))
                        }
                    </div>
                </div>
            </div>

        </div>
    </>);
};

export default ActionSelection;